<template>
  <button
    class="button-text w-full border-b px-6 py-2 hover:bg-gray-50 hover:text-gray-800 cursor-pointer"
    :class="{ ['button-text--child']: nestedLevel > 0 }"
    @keyup.enter="handleClick(item)"
    @click="handleClick(item)"
  >
    {{ item.title }}
  </button>
  <ul v-if="item.children">
    <LinksList :items="item.children" :nested-level="nestedLevel + 1" />
  </ul>
</template>

<script setup lang="ts">
import { inject, Ref } from "vue";

import LinksList from "@/components/shared/LinksList.vue";

import { useNavigatorWithHistory } from "../navigator";
import { TocItem } from "../navigator/types";
import MediaPlayer from "@/services/media/player";

defineProps<{
  nestedLevel: number;
  item: Readonly<TocItem>;
}>();

const navigator = useNavigatorWithHistory();
const mediaPlayer = inject("mediaPlayer") as Ref<MediaPlayer>;

async function handleClick(item: TocItem): Promise<void> {
  if (mediaPlayer.value) mediaPlayer.value.stop();
  await navigator.go(item.target);
}
</script>

<style lang="scss" scoped>
@use "@/assets/styles/variables.scss" as *;
.button-text {
  &--child {
    width: calc(100% - $spacingM * v-bind(nestedLevel));
    margin-left: calc($spacingM * v-bind(nestedLevel));
  }
}
</style>
